import { ReactNode } from 'react';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { IconSemiCircle } from '@/common/components/Icons/custom/IconSemiCircle';
import { Stack } from '@/common/components/Stack/Stack';

export type THalfCirclePointProps = {
  children: ReactNode;
};

export function HalfCirclePoint({ children }: THalfCirclePointProps) {
  return (
    <Stack horizontal gap="sm" align="center">
      <IconSemiCircle width={12} height={12} />
      <BodyText className="text-sm/[1.5] md:text-md/[1.5]">{children}</BodyText>
    </Stack>
  );
}
